module.exports = __webpack_public_path__ + "img/Group 27703@2x.b2115764.png";